import atsDark from './atsDark';
import atsFancy from './atsFancy';
import { CustomTheme } from './types';

const themes: Record<string, CustomTheme> = {
  atsFancy,
  atsDark,
};
export default themes;
